import Axios from "axios";
import { myStore } from ".";
import { handleInvalidToken } from "./store/reducers/tokenReducer";

const devUrl = "http://13.41.109.19"; // Dev server
const liveUrl = "https://backend.alphacapitalgroup.uk"; // Production server
const uatUrl = "https://backend-uat.alphacapitalgroup.uk"; // UAT server

// Determine the base URL dynamically based on hostname
export const baseUrl = (() => {
  const { hostname } = window.location;

  if (hostname === "localhost") {
    return liveUrl; // Use dev server for local development
  } else if (hostname.includes("uat")) {
    return uatUrl; // More flexible UAT condition
  } else if (hostname === "user-dev.alphacapitalgroup.uk") {
    return liveUrl; // Handle other dev environments
  }
  return liveUrl; // Default to production
})();

// Set Axios default base URL
Axios.defaults.baseURL = baseUrl;

// Create a new Axios instance for interceptors
export const axiosInstance = Axios.create({
  baseURL: baseUrl,
});

let refreshPromise = null;
const clearRefreshPromise = () => (refreshPromise = null);
console.log(window.location.origin, "origin");
axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // If idToken expired, get a fresh token and process the request
    if (
      error.response.status === 401 &&
      error.response.data?.detail === "invalid-auth-token" &&
      !originalRequest._retry
    ) {
      const { getState, dispatch } = myStore;
      originalRequest._retry = true;
      if (!refreshPromise) {
        refreshPromise = dispatch(handleInvalidToken())
          .then((token) => {
            return token;
          })
          .catch((error) => {
            return Promise.reject(error);
          })
          .finally(clearRefreshPromise);
      }
      const token = await refreshPromise;
      originalRequest.headers.Authorization = token;
      return axiosInstance(originalRequest);
    }
    return Promise.reject(error);
  }
);
